import { transition, trigger, useAnimation } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { notify } from 'app/store/common-effects/notifier.effects';
import { OrderCodeService } from 'core/http/project/orderCodeService';
import { reloadableRequest } from 'core/utils/reloadable-request';
import { ClipboardService } from 'ngx-clipboard';
import { Subject } from 'rxjs';
import { hideAnimation, showAnimation } from 'shared/common/animations';

@Component({
  selector: 'app-order-code',
  templateUrl: './order-code-dialog.component.html',
  styleUrls: ['./order-code-dialog.component.scss'],
  animations: [
    trigger('show', [
      transition('void => *', [
        useAnimation(showAnimation),
      ]),
    ]),
    trigger('hide', [
      transition('* => void', [
        useAnimation(hideAnimation),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderCodeDialogComponent {
  readonly reload = new Subject<void>();
  readonly requestStatus = { loading: false, failed: false };
  readonly code$ = reloadableRequest(
    () => this.devService.generateOrderCode(this.data),
    this.reload,
    this.requestStatus,
    () => this.cd.markForCheck(),
  );

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private devService: OrderCodeService,
    private clipboard: ClipboardService,
    private store$: Store,
    private cd: ChangeDetectorRef,
  ) { }

  copyCode(code: string): void {
    this.clipboard.copy(code);
    this.store$.dispatch(notify({ message: 'NOTIFICATIONS.order_code_copied' }));
  }
}
